import {
	type CollectionModelField,
	CollectionModelFieldAnchor,
	CollectionModelFieldAssetType,
	CollectionModelFieldDate,
	CollectionModelFieldFileTool,
	CollectionModelFieldHeight,
	CollectionModelFieldImage,
	CollectionModelFieldLine,
	CollectionModelFieldLocation,
	CollectionModelFieldNestedList,
	CollectionModelFieldNumber,
	CollectionModelFieldOrientation,
	CollectionModelFieldSelectList,
	CollectionModelFieldText,
	CollectionModelFieldTrueSize,
	CollectionModelFieldVector,
	CollectionModelFieldVerticalSeparation,
	CollectionModelFieldYesNo,
} from '@ikegps/core-shared';
import { AnchorManualFieldView, AnchorP2PFieldView } from './anchor.field.view';
import { AssetTypeFieldView } from './asset.type.field.view';
import { DateFieldView } from './date.field.view';
import { type CollectionFieldView, SimpleFieldView } from './field.view';
import { FileToolFieldView } from './file.tool.field.view';
import { HeightFieldView } from './height.field.view';
import { ImageFieldView } from './image.field.view';
import { LineFieldView } from './line.field.view';
import { LocationFieldView } from './location.field.view';
import { NestedListFieldView } from './nested.list.field.view';
import { NumberFieldView } from './number.field.view';
import { OrientationFieldView } from './orientation.field.view';
import { SelectListFieldView } from './select.list.field.view';
import { TextFieldView } from './text.field.view';
import { TrueSizeView } from './true.size.view';
import { VectorCollectionFieldView } from './vector.collection.field.view';
import { VectorManualFieldView } from './vector.manual.field.view';
import { VectorP2PFieldView } from './vector.p2p.field.view';
import { VerticalSeparationFieldView } from './vertical.separation.field.view';
import { YesNoFieldView } from './yesno.field.view';

export class CollectionFieldViewBuilder {
	static getFieldView(field: CollectionModelField): CollectionFieldView {
		if (CollectionModelFieldNumber.isNumberField(field)) {
			return NumberFieldView;
		}

		if (CollectionModelFieldOrientation.isOrientationField(field)) {
			return OrientationFieldView;
		}

		if (CollectionModelFieldText.isTextField(field)) {
			return TextFieldView;
		}

		if (CollectionModelFieldFileTool.isFileToolField(field)) {
			return FileToolFieldView;
		}

		if (CollectionModelFieldLocation.isLocationField(field)) {
			return LocationFieldView;
		}

		if (CollectionModelFieldDate.isDateField(field)) {
			return DateFieldView;
		}

		if (CollectionModelFieldYesNo.isYesNoField(field)) {
			return YesNoFieldView;
		}

		if (CollectionModelFieldVector.isVectorField(field)) {
			if (field.provider === CollectionModelFieldVector.PROVIDER_P2P) {
				return VectorP2PFieldView;
			}

			if (field.provider === CollectionModelFieldVector.PROVIDER_COLLECTION) {
				return VectorCollectionFieldView;
			}

			return VectorManualFieldView;
		}
		if (CollectionModelFieldAnchor.isAnchorField(field)) {
			if (field.tool === CollectionModelFieldAnchor.COLLLECTION_TOOL_LOCATION) {
				return AnchorManualFieldView;
			}

			if (field.tool === CollectionModelFieldAnchor.COLLLECTION_TOOL_VECTOR) {
				if (field.provider === CollectionModelFieldAnchor.PROVIDER_P2P) {
					return AnchorP2PFieldView;
				}
				return AnchorManualFieldView;
			}
		}

		if (CollectionModelFieldImage.isImageField(field)) {
			return ImageFieldView;
		}

		if (CollectionModelFieldHeight.isHeightField(field)) {
			return HeightFieldView;
		}

		if (CollectionModelFieldVerticalSeparation.isVerticalSeparationField(field)) {
			return VerticalSeparationFieldView;
		}

		// MidSpan renders as an IKE Photo; what makes it a MidSpan is the derived locked base on the capture.
		if (CollectionModelFieldTrueSize.isMeasurableIkePhotoField(field)) {
			return TrueSizeView;
		}

		if (CollectionModelFieldNestedList.isNestedListField(field)) {
			return NestedListFieldView;
		}

		if (CollectionModelFieldSelectList.isSelectListField(field)) {
			return SelectListFieldView;
		}

		if (CollectionModelFieldLine.isLineField(field)) {
			return LineFieldView;
		}

		if (CollectionModelFieldAssetType.isAssetTypeField(field)) {
			return AssetTypeFieldView;
		}

		return SimpleFieldView;
	}
}
